<template>
  <el-card style="margin-top: 20px">
    <div class="title">
      <span></span>
      信息确认
    </div>
    <el-descriptions
        style="margin-bottom:10px "
        class="margin-top"
        border

        column="3">
      <el-descriptions-item span="3" label="照片:" label-align="right" align="left" label-class-name="my-label"
      >
        <el-image style="width: 150px;" src="/api/study/user/information/getStudentPhoto" fit="fit" />
      </el-descriptions-item>
      <el-descriptions-item span="3" label="姓名:" label-align="right" align="left"  label-class-name="my-label"
      >{{studentInfo.name}}</el-descriptions-item>
      <el-descriptions-item span="3" label="性别:" label-align="right" align="left"  label-class-name="my-label"
      >{{studentInfo.sex}}</el-descriptions-item>
      <el-descriptions-item span="3" label="出生日期:" label-align="right" align="left"  label-class-name="my-label"
      >{{new Date(studentInfo.birthday).format('yyyy年MM月dd日')}}</el-descriptions-item>
      <el-descriptions-item span="3" label="专业:" label-align="right" align="left"  label-class-name="my-label"
      >{{studentInfo.speciality}}</el-descriptions-item>
      <el-descriptions-item span="3" label="层次:" label-align="right" align="left"  label-class-name="my-label"
      >{{studentInfo.study_level}}</el-descriptions-item>
      <el-descriptions-item span="3" label="学习中心:" label-align="right" align="left"  label-class-name="my-label"
      >{{studentInfo.center_name}}</el-descriptions-item>
      <el-descriptions-item span="3" label="手机号码:" label-align="right" align="left"  label-class-name="my-label"
      >

        <div class="info-item">

         <span>{{studentInfo.mobile_phone}}</span>
          <span v-if="!studentInfo.authentication">
          <el-icon style="color: #2dc26b;font-size: 20px;cursor: pointer"><Edit  @click="editPhoneVisible=true"/></el-icon>
        </span>
          <div class="msg"> (务必仔细核对与填写)</div>
        </div>


      </el-descriptions-item>
      <el-descriptions-item span="3" label="证件号码:" label-align="right" align="left"  label-class-name="my-label"
      >
        <div class="info-item">
          <span>  {{studentInfo.id_card}}</span>

          <div class="msg"> (务必仔细核对)</div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item span="3" label="学习形式:" label-align="right" align="left"  label-class-name="my-label"
      >
        <div class="info-item">
          <span>{{studentInfo.study_type}}</span>

          <div class="msg"> (务必仔细核对)</div>
        </div>



      </el-descriptions-item>
      <el-descriptions-item span="3" label="高中（专科）毕业学校:" label-align="right" align="left"  label-class-name="my-label"
      >
        <div class="info-item">
          <el-input v-model="studentInfo.graduate_school"></el-input>
          <div class="msg"> (务必仔细核对与填写)</div>
        </div>

      </el-descriptions-item>
      <el-descriptions-item span="3" label="籍贯:" label-align="right" align="left"  label-class-name="my-label"
      >
        <div class="info-item">
          <el-cascader v-model="region" :options="options"  :props="props" :placeholder="placeholder"/>
          <div class="msg"> (务必仔细核对与填写)</div>
        </div>

      </el-descriptions-item>
      <el-descriptions-item span="3" label="家庭地址:" label-align="right" align="left"  label-class-name="my-label"
      >
        <div class="info-item">
          <el-input v-model="studentInfo.home_address"></el-input>
          <div class="msg"> (务必仔细核对与填写)</div>
        </div>

      </el-descriptions-item>
      <el-descriptions-item span="3" label="家庭电话:"  label-align="right" align="left"  label-class-name="my-label"
      >
        <div class="info-item">
          <el-input v-model="studentInfo.home_phone"></el-input>
          <div class="msg"> (务必仔细核对与填写)</div>
        </div>


      </el-descriptions-item>
      <el-descriptions-item span="3" label="温馨提示:" label-align="right" align="left"  label-class-name="my-label"
      ><span style="color:red;">以上信息关系到您今后的毕业信息，非常重要！如果上述无误，请直接确认！</span></el-descriptions-item>
    </el-descriptions>
    <span v-if="studentInfo.authentication"  style="color: red;margin-left: 10px;color: red">您已经确认信息，无法再次修改!若有疑问请联系中心管理人员。</span>
    <div v-else>
      <el-button type="primary" @click="save()">保存信息</el-button>
      <el-button type="danger" @click="confirm()">确认信息</el-button>
    </div>
    </el-card>
    <eidt-phone v-model="editPhoneVisible" :is-verification="studentInfo.auth_id" @success="loadData"></eidt-phone>
</template>
<script setup>

import {reactive, ref} from "vue";
import {ElMessage, ElMessageBox} from "element-plus";
import { Edit } from '@element-plus/icons-vue'
import eidtPhone from './eidtPhone.vue'
import {
  confirmRecordVerificationStatus, getBuildARegionalTreeStructure,
  updateStudentRecordInformation,
  verifyStudentPersonalInformation
} from "../../../api/mine";
import {Plus} from "@element-plus/icons-vue";

const studentInfo = ref({

})
const props = {
  value:'content',
  label:'content',
  children:'region'
}
const editPhoneVisible=ref(false)
const options = ref([])
const region=ref([])
const placeholder=ref("")
const loadData =  () => {
  verifyStudentPersonalInformation().then(data => {
    studentInfo.value = data.datas.record;
    if(studentInfo.value.home_province!=undefined){
      placeholder.value=studentInfo.value.home_province+studentInfo.value.student_city+studentInfo.value.student_district
    }else {
      placeholder.value="请选择"
    }


    region.value.push(studentInfo.value.home_province)
    region.value.push(studentInfo.value.student_city)
    region.value.push(studentInfo.value.student_district)
    console.log(region);
  })
  getBuildARegionalTreeStructure().then(data => {
    options.value=data.datas.region

  })
}
loadData()
const save = () => {
  const data = {
    graduate_school: studentInfo.value.graduate_school,
    home_province: region.value[0],
    student_city: region.value[1],
    student_district: region.value[2],
    home_address: studentInfo.value.home_address,
    home_phone: studentInfo.value.home_phone
  }
  updateStudentRecordInformation(data).then(res => {
      if(res.success){
        loadData()
        ElMessage.success(res.message)
      }else {
        ElMessage.error(res.message)
      }
  })
}

const confirm = () => {
  ElMessageBox.confirm(
      '确认后您将无法再次修改信息。 是否确认修改?',
      '注意',
      {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'Warning',
      }
  )
  .then(() => {
    const data = {
      graduate_school: studentInfo.value.graduate_school,
      home_province: region.value[0],
      student_city: region.value[1],
      student_district: region.value[2],
      home_address: studentInfo.value.home_address,
      home_phone: studentInfo.value.home_phone
    }
    confirmRecordVerificationStatus(data).then(res => {
      if(res.success){
        loadData()
        ElMessage.success(res.message)
      }else {
        ElMessage.error(res.message)
      }
    })
  })
  .catch(() => ElMessage.info('取消修改'))
}

</script>
<style lang="scss" scoped>
.title{
  font-family: Calibri;
  line-height: 60px;
  font-weight: 500;
  span{
    display: inline-block;
    height: 15px;
    width: 6px;
    background: red;
    margin: 0 10px;
    border-radius: 10px;
    vertical-align: middle;
  }
}
.info-item{
  display: flex;
.msg{
  color: red;
  width: 300px;
  line-height: 22px;
  margin-left: 10px;
}
}
</style>

<style>
.my-label{
  width: 180px;
}
</style>